import { Link, useParams } from 'react-router';

import { useNewsPost } from '../api/hooks.js';
import { ErrorState, Loading } from '../components/states.js';
import { Markdown } from '../components/Markdown.js';
import { formatDate } from '../util/format.js';

export function NewsPostPage() {
  const { slug = '' } = useParams();
  const { data, isPending, error } = useNewsPost(slug);

  return (
    <article className="mx-auto max-w-3xl pt-8">
      <Link to="/news" className="eyebrow hover:text-brass-200">
        ← All news
      </Link>

      {isPending ? <Loading /> : null}
      {error ? <ErrorState error={error} action="Log in to read this post." /> : null}

      {data ? (
        <>
          <h1
            className="mt-4 border-b-2 border-brass-400 pb-3 font-display text-5xl font-bold
            uppercase leading-[0.9] tracking-tight text-field-50"
          >
            {data.title}
          </h1>
          <p className="mt-3 font-display text-xs font-semibold uppercase tracking-bug text-field-500">
            {data.authorName}
            {data.publishedAt ? ` · ${formatDate(data.publishedAt)}` : ' · unpublished draft'}
          </p>
          <div className="mt-6">
            <Markdown>{data.body}</Markdown>
          </div>
        </>
      ) : null}
    </article>
  );
}
